interface OptionChainLandingModeParams {
  isOptionInstrument: boolean
  isOpenedFromOptionChain: boolean
}

/**
 * Pick the view shown when a concrete chart symbol becomes active.
 *
 * A perp/spot/future with a fallback option family always lands on Chart. An option
 * tab always lands on Option Chain, except when a contract was explicitly opened
 * from the currently visible chain for the purpose of viewing its chart.
 */
export function resolveOptionChainLandingVisibility({
  isOptionInstrument,
  isOpenedFromOptionChain,
}: OptionChainLandingModeParams): boolean {
  if (!isOptionInstrument) return false
  return !isOpenedFromOptionChain
}
